import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrComponent } from "../util/toastr/toastr.component";
import { Misc } from "../util/misc";
import { Cliente } from "src/app/models/cliente.model";
import { Projeto } from "src/app/models/projeto.model";
import { ClienteService } from "src/app/services/cliente.service";
import { EstimativaService } from "src/app/services/estimativa.service";
import { ProjetoService } from "src/app/services/projeto.service";
import { CrmService } from "src/app/services/crm.service";
import { VwCrmModel } from "src/app/models/vw.crm.model";
import * as constants from "src/app/models/constants/constants";
import { Router } from "@angular/router";
import { forEach } from "lodash";
import { UtilService } from "src/app/services/util.service";
import { map, Observable, startWith } from "rxjs";

@Component({
  selector: "app-estimativa-duplicar-component",
  templateUrl: "estimativa-duplicar.component.html",
  styleUrls: ["estimativa-duplicar.component.scss"],
})
export class EstimativaDuplicarComponent implements OnInit {
  basicForm: UntypedFormGroup;
  clientes: Cliente[] = [];
  projetos: Projeto[] = [];
  possuiProjetos = true;
  loading = true;
  novoProjeto: boolean = false;
  cliente: Cliente;
  perfil: any;
  valorIdPerfil: number;
  habilitarCampoPerfil: boolean = false;
  tipoDelivery: boolean = false;
  perfilId: any;
  vwClienteCrm: VwCrmModel[];
  propostas = true;
  quotePartial: string;
  nomeOportuinidadeParcial: string;
  crmPrefix = "P" + new Date().getFullYear();
  novaEstimativa: number;
  valoresRepetidos = [];
  doubleDataSource = [];
  dadosEmUso = [];
  dadosDesordenado = [];
  accountId: any;
  clienteID: any;
  projetoID: any;

  filtroProposta: UntypedFormControl = new UntypedFormControl();
  propostasFiltradas: Observable<any[]>;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<EstimativaDuplicarComponent>,
    private clienteService: ClienteService,
    private estimativaService: EstimativaService,
    private projetoService: ProjetoService,
    private toastr: ToastrComponent,
    private crmService: CrmService,
    public misc: Misc,
    private router: Router,
    public utilService: UtilService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.createForm();
  }

  getPerfilUsuario() {
    this.perfil = JSON.parse(localStorage.getItem("currentUserPricingWeb"));
    this.perfil.perfil.forEach((element) => {
      this.perfilId = this.perfil.id;
      this.valorIdPerfil = element.id;
    });
  }

  ngOnInit() {
    this.getPerfilUsuario();
    const ele = this.data.element;
    this.clienteID = this.data.element.clienteId;
    this.projetoID = this.data.element.projetoId;
    this.clienteSelecionado(ele.clienteId);

    this.habilitarCampoPerfil =
      this.valorIdPerfil == constants.PerfilConstants.ID_PERFIL_ADMINISTRADOR;

    if (
      this.valorIdPerfil != constants.PerfilConstants.ID_PERFIL_ADMINISTRADOR &&
      this.data.edit
    ) {
      this.basicForm.patchValue({
        clienteId: ele.clienteId,
        nome: ele.nome,
      });

    }

    this.tipoDelivery =
      this.valorIdPerfil == constants.PerfilConstants.ID_PERFIL_DELIVERY;

    if (this.tipoDelivery) {
      this.basicForm.patchValue({
        clienteId: ele.clienteId,
        projetoId: ele.projetoId,
      });

    }

    this.loading = true;

    var isAdmin = this.utilService.isAdmin();

    if (isAdmin) {
      this.clienteService.getAllAtivos().subscribe(
        (clientes) => {
          this.clientes = clientes.items;
          this.loading = false;
        },
        (error) => {
          this.misc.processError(
            error,
            "Não foi possível duplicar a estimativa."
          );
        },
        () => {
          this.loading = false;
        }
      );
    } else {
      var unidadeId = this.utilService.getUnidadeId();
      this.clienteService.getAllByUnidade(unidadeId).subscribe(
        (clientes: any) => {
          this.clientes = Array.isArray(clientes) ? clientes : (clientes?.items ?? []);
          this.loading = false;
        },
        (error) => {
          this.misc.processError(
            error,
            "Não foi possível duplicar a estimativa."
          );
        },
        () => {
          this.loading = false;
        }
      );
    }

    this.propostasFiltradas = this.filtroProposta.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterPropostas(value))
    );

  }

  createForm() {
    this.basicForm = this.fb.group({
      clienteId: [null, [Validators.required]],
      projetoId: [null, [Validators.required]],
      nome: [null, [Validators.required]],
      justificativa: [null, [Validators.required]],
      novoProjeto: [null],
    });
  }

  clienteSelecionado(cliente: Cliente) {
    this.projetos = null;
    this.possuiProjetos = false;

    this.basicForm.patchValue({
      projetoId: null,
      clienteId: null,
    });

    if (cliente) {
      this.basicForm.patchValue({
        clienteId: cliente.id,
      });

      this.projetoService.getByClienteId(cliente.id).subscribe((projetos) => {
        this.projetos = projetos;
        this.possuiProjetos = this.projetos.length > 0;
        this.adicionarProjeto();
      });
    }
  }

  getClienteLabel() {
    const element = this.data.element;
    return `${element.clienteNome}`;
  }

  getPropostaLabel() {
    const element = this.data.element;
    return `${element.crmId} | ${element.projetoNome}`;
  }

  close(): void {
    this.dialogRef.close();
  }

  adicionarProjeto() {
    this.novoProjeto = !this.novoProjeto;
    this.loading = true;

    this.crmService
      .getClientesCrm(this.accountId)
      .subscribe({
        next: (cotacoes) => {
          this.vwClienteCrm = cotacoes ?? [];

          this.doubleDataSource = [];
          this.dadosEmUso = [];

          let clienteCRMFiltrado = this.vwClienteCrm.map((vw) => vw);
          let projetoFiltrado = (this.projetos || []).map((proj) => proj);

          this.valoresRepetidos = clienteCRMFiltrado.filter((c) =>
            projetoFiltrado.find((p) => p.crmId == c.quote_No)
          );

          clienteCRMFiltrado.forEach((item, index, arr) => {
            if (
              !this.valoresRepetidos.find((b) => b.quote_No == item.quote_No)
            ) {
              this.doubleDataSource.push(item);
            }
          });

          this.dadosDesordenado = this.doubleDataSource.concat(projetoFiltrado);

          let itensOrdemUnificado = [];

          this.dadosDesordenado.forEach((ele) => {
            if (ele.quote_No) {
              itensOrdemUnificado.push(ele.quote_No.replace("P", ""));
            }
            if (ele.crmId) {
              itensOrdemUnificado.push(ele.crmId.replace("P", ""));
            }
          });

          itensOrdemUnificado.sort().reverse();
          itensOrdemUnificado.forEach((item) => {
            this.dadosDesordenado.filter((ele) => {
              let elemento = ele.quote_No
                ? ele.quote_No.replace("P", "")
                : ele.crmId.replace("P", "");

              if (elemento == item) {
                if (ele.nome_Oportunidade === null)
                  ele.nome_Oportunidade = ele.assunto;

                let existeNaLista = this.dadosEmUso.find(x => x.quote_No ? x.quote_No === ele.quote_No : x.crmId === ele.crmId);
                if (!existeNaLista)
                  this.dadosEmUso.push(ele);
              }
            });
          });

          this.filtroProposta.setValue(this.filtroProposta.value ?? '', { emitEvent: true });
        },

        error: (error) => {
          this.misc.processError(
            error,
            "Não foi possível carregar a lista de projetos."
          );
        },
      })
      .add(() => {
        this.loading = false;
      });
  }

  carregaProjetos(cliente: Cliente) {
    this.limparDadosCombos();

    this.novoProjeto = false;
    this.accountId = cliente.accountId;

    this.basicForm.patchValue({
      clienteId: cliente.id,
    });

    if (cliente) {
      this.loading = true;

      this.projetoService
        .getByClienteId(cliente.id)
        .subscribe({
          next: (projetos) => {
            this.projetos = projetos;
            this.adicionarProjeto();
          },
          error: (error) => {
            this.misc.processError(
              error,
              "Não foi possível carregar a lista de projetos."
            );
          },
        })
        .add(() => {
          this.loading = false;
        });
    }
    this.filtroProposta.setValue('');
  }

  save() {
    this.loading = true;

    const estimativa = {
      id: this.data.estimtvId,
      nome: this.basicForm.value.nome,
      usuarioId: this.perfilId,
      projetoId: this.basicForm.value.projetoId.quote_No
        ? 0
        : this.basicForm.value.projetoId,
      negocioId: 1,
      pracaId: 1,
      statusId: 1,
      ratecard: 1,
      unidadeId: 1,
    };

    console.log("estimativa", estimativa)

    if (this.basicForm.value.projetoId.quote_No) {
      const projeto = {
        id: 0,
        clienteId: this.basicForm.value.clienteId,
        crmId: this.basicForm.value.projetoId.quote_No,
        ano: new Date().getFullYear().toString(),
        nome: this.basicForm.value.projetoId.nome_Oportunidade,
        usuarioId: this.utilService.getUserId(),
        tbEstimativa: [estimativa],
      };

      this.loading = true;
      this.projetoService.create(projeto as Projeto).subscribe({
        next: (result) => {
          estimativa.projetoId = result.id;
          this.duplicarEstimativa(estimativa);
        },
        error: (error) => {
          this.misc.processError(error);
          this.toastr.mostrarMensagem(
            "erro",
            "Erro",
            "Ocorreu um erro ao criar o projeto da estimativa, contate o administrador."
          );
          this.loading = false;
        },
      });
    } else {
      this.duplicarEstimativa(estimativa);
    }
  }

  funcaoTeste(): any {
    return true;
  }

  duplicarEstimativa(estimativa: any) {
    this.loading = true;
    if (estimativa.projetoId) {
      const dados = {
        projetoId: typeof estimativa.projetoId === "number" ? estimativa.projetoId : estimativa.projetoId.id, //9761 -Erro na duplicação onde o projeto já existe na tabela pw
        estimativaId: this.data.estimtvId,
        nome: this.basicForm.value.nome,
        usuarioId: this.perfilId,
        justificativa: this.basicForm.value.justificativa,
      };

      console.log("dados", dados)

      this.loading = true;
      this.estimativaService.duplicar(dados).subscribe(
        (result: any) => {
          const estimativaId = result?.objeto?.estimativaId ?? result?.estimativaId;
          this.toastr.mostrarMensagem(
            "sucesso",
            "Sucesso",
            "Registro duplicado com sucesso."
          );
          if (estimativaId != null) {
            this.router.navigate([
              "/price/projeto/estimativa-edit/" + estimativaId,
            ]);
          }
          this.loading = false;
          this.close();
        },
        (error) => {
          if (error.status === 400) {
            this.toastr.mostrarMensagem(
              "erro",
              "Erro",
              "Atualização não permitida. O nome escolhido já é usado em outra estimativa para esta proposta."
            );
            this.loading = false;
          } else {
            this.misc.processError(error);
            this.toastr.mostrarMensagem(
              "erro",
              "Erro",
              "Ocorreu um erro ao duplicar o registro, contate o administrador."
            );
            this.loading = false;
          }
        },
        () => {
          this.loading = false;
        }
      );
    }
    this.loading = true;

    if (this.basicForm.value.projetoId.quote_No === 10) {
      const projeto = {
        id: 0,
        clienteId: this.basicForm.value.clienteId,
        crmId: this.basicForm.value.projetoId.quote_No,
        ano: new Date().getFullYear().toString(),
        nome: this.basicForm.value.projetoId.assunto,
        usuarioId: this.perfilId,
      } as Projeto;

      this.loading = true;
      this.projetoService.create(projeto).subscribe(
        (result) => {
          this.novaEstimativa = result.id;

          const dados = {
            projetoId: this.novaEstimativa,
            estimativaId: this.data.estimtvId,
            nome: this.basicForm.value.nome,
            usuarioId: this.perfilId,
            justificativa: this.basicForm.value.justificativa,
          };

          this.loading = true;
          this.estimativaService.duplicar(dados).subscribe();
        },
        (error) => {
          this.loading = false;
          this.misc.processError(error);
        },
        () => {
          this.toastr.mostrarMensagem(
            "sucesso",
            "Sucesso",
            "Registro duplicado com sucesso."
          );
          this.close();
          this.loading = false;
        }
      );
    }

    if (!estimativa.projetoId) {
      this.misc.processError("Não foi possível duplicar registro pois não existe Id do Projeto vindo do CRM.");
      this.loading = false;
    }
  }

  onEnableInputs(vw: VwCrmModel) {
    if (vw.quote_No) {
      this.quotePartial = vw.quote_No.toString();
    }

    if (vw.nome_Oportunidade) {
      this.nomeOportuinidadeParcial = vw.nome_Oportunidade;
    }
  }

  limpar() {
    this.basicForm.get("projeto").disable();
    this.basicForm.get("novoProjeto").disable();
    this.basicForm.get("estimativa").disable();
    this.basicForm.get("estimativaTipo").disable();

    this.basicForm.patchValue({
      projeto: null,
      novoProjeto: "",
      crm: "0000",
      estimativa: "",
      estimativaTipo: null,
    });
  }

  displayFn(cliente: Cliente): string {
    return cliente && cliente.nome ? cliente.nome : "";
  }

  limparDadosCombos() {
    if (this.projetos && this.projetos.length > 0) {
      this.projetos.splice(0, this.projetos.length);
      this.projetos = [];
    }

    if (this.dadosEmUso && this.dadosEmUso.length > 0) {
      this.dadosEmUso.splice(0, this.dadosEmUso.length);
      this.dadosEmUso = [];
    }

    if (this.dadosDesordenado && this.dadosDesordenado.length > 0) {
      this.dadosDesordenado.splice(0, this.dadosDesordenado.length);
      this.dadosDesordenado = [];
    }

    if (this.valoresRepetidos && this.valoresRepetidos.length > 0) {
      this.valoresRepetidos.splice(0, this.valoresRepetidos.length);
      this.valoresRepetidos = [];
    }

    if (this.doubleDataSource && this.doubleDataSource.length > 0) {
      this.doubleDataSource.splice(0, this.doubleDataSource.length);
      this.doubleDataSource = [];
    }
  }

  get dadosEmUsoFiltrados(): any[] {
    return this.dadosEmUso.filter(
      (p) => !['Cancelada', 'Erro', 'Rejected'].includes(p.estagio)
    );
  }

  onFocusProposta() {
    if (!this.filtroProposta.value) {
      this.filtroProposta.setValue('');
    }
  }

  private _filterPropostas(value: any): any[] {
    const filterValue =
      typeof value === 'string' ? value.toLowerCase() : '';

    return this.dadosEmUsoFiltrados.filter((p) => {
      const termo = (
        (p.crmId || p.quote_No || '') +
        ' ' +
        (p.nome || p.nome_Oportunidade || p.assunto || '')
      ).toLowerCase();

      return termo.includes(filterValue);
    });
  }

  displayPropostaFn(projeto: any): string {
    if (!projeto) return '';
    return `${projeto.crmId || projeto.quote_No || ''} | ${projeto.nome || projeto.nome_Oportunidade || projeto.assunto || ''
      }`;
  }
}
